import * as React from "react";
import { cn } from "../../lib/utils";
import { PACKAGE_CARD_STYLES } from "./constants";
import type { PackageCardProps } from "./types";

function formatCurrency(amount: number, currency: string, locale: string) {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}

function HotelIcon() {
  return (
    <svg
      className={PACKAGE_CARD_STYLES.detailIcon}
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M0 5.24354C0 4.82799 0.147153 4.47521 0.441458 4.18521C0.735903 3.89507 1.0909 3.75 1.50646 3.75H1.66667V1.50646C1.66667 1.0909 1.81382 0.735973 2.10812 0.441667C2.40257 0.147223 2.75757 0 3.17313 0H12.6602C13.0758 0 13.4308 0.147223 13.7252 0.441667C14.0195 0.735973 14.1667 1.0909 14.1667 1.50646V3.75H14.3269C14.7424 3.75 15.0974 3.89715 15.3919 4.19146C15.6862 4.4859 15.8333 4.8409 15.8333 5.25646V7.83333C15.8333 8.08861 15.7444 8.30521 15.5665 8.48313C15.3885 8.66104 15.1719 8.75 14.9167 8.75L14.5465 10.194C14.524 10.2612 14.486 10.3151 14.4327 10.3558C14.3792 10.3964 14.3189 10.4167 14.2517 10.4167H14.0817C14.0144 10.4167 13.9541 10.3964 13.9006 10.3558C13.8473 10.3151 13.8094 10.2612 13.7869 10.194L13.4167 8.75H2.41667L2.04646 10.194C2.02396 10.2612 1.98604 10.3151 1.93271 10.3558C1.87924 10.3964 1.81889 10.4167 1.75167 10.4167H1.58167C1.51444 10.4167 1.4541 10.3964 1.40062 10.3558C1.34729 10.3151 1.30938 10.2612 1.28688 10.194L0.916667 8.75C0.661389 8.75 0.444792 8.66104 0.266875 8.48313C0.0889583 8.30521 0 8.08861 0 7.83333V5.24354ZM8.54167 3.75H12.9167V1.50646C12.9167 1.43174 12.8926 1.37028 12.8446 1.32208C12.7965 1.27403 12.7351 1.25 12.6602 1.25H8.54167V3.75ZM2.91667 3.75H7.29167V1.25H3.17313C3.09826 1.25 3.03681 1.27403 2.98875 1.32208C2.94069 1.37028 2.91667 1.43174 2.91667 1.50646V3.75ZM1.25 7.5H14.5833V5.25646C14.5833 5.1816 14.5593 5.12014 14.5112 5.07208C14.4632 5.02403 14.4017 5 14.3269 5H1.50646C1.4316 5 1.37014 5.02403 1.32208 5.07208C1.27403 5.12014 1.25 5.1816 1.25 5.25646V7.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

function FlightIcon() {
  return (
    <svg
      className={PACKAGE_CARD_STYLES.detailIcon}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M5.99874 5.87021L0.726237 3.61208C0.446376 3.49139 0.277626 3.28764 0.219987 3.00083C0.162209 2.71389 0.241237 2.4625 0.45707 2.24667L0.726237 1.96958C0.821376 1.87445 0.934084 1.80576 1.06436 1.76354C1.19478 1.72132 1.32999 1.71146 1.46999 1.73396L8.84978 3.02729L11.4489 0.415001C11.7258 0.138334 12.0634 0 12.4619 0C12.8603 0 13.1979 0.138334 13.4746 0.415001C13.7514 0.691668 13.8898 1.02931 13.8898 1.42792C13.8898 1.82639 13.7514 2.16396 13.4746 2.44063L10.8752 5.05271L12.1558 12.4198C12.1782 12.5598 12.1704 12.6971 12.1325 12.8317C12.0946 12.9663 12.028 13.0811 11.9329 13.1763L11.6558 13.4325C11.44 13.6483 11.1865 13.7296 10.8954 13.6763C10.6043 13.6228 10.3983 13.4561 10.2775 13.1763L8.03228 7.89563L5.69103 10.2242L6.14124 12.8156C6.16374 12.9278 6.1595 13.0365 6.12853 13.1417C6.09756 13.2469 6.04145 13.3402 5.9602 13.4215L5.6702 13.7033C5.50783 13.8658 5.31367 13.9289 5.0877 13.8925C4.86172 13.8563 4.69263 13.7372 4.5804 13.5352L3.10769 10.7948L0.367278 9.32208C0.165334 9.20986 0.0462366 9.04076 0.00998661 8.81479C-0.0264023 8.58882 0.0366533 8.39465 0.199153 8.23229L0.481028 7.94229C0.562278 7.86104 0.655542 7.80361 0.76082 7.77C0.865959 7.73639 0.974639 7.73076 1.08686 7.75313L3.6654 8.19875L5.99874 5.87021Z"
        fill="currentColor"
      />
    </svg>
  );
}

function CarIcon() {
  return (
    <svg
      className={PACKAGE_CARD_STYLES.detailIcon}
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M1.76271 10.8333V11.6185C1.76271 11.8634 1.67694 12.0715 1.50542 12.2429C1.33389 12.4143 1.12556 12.5 0.880417 12.5C0.635417 12.5 0.427431 12.4143 0.256458 12.2429C0.0854861 12.0715 0 11.8634 0 11.6185V5.74042C0 5.65389 0.00562495 5.56736 0.016875 5.48083C0.028125 5.39431 0.0470139 5.31139 0.0735416 5.23208L1.56583 1.01292C1.66569 0.712778 1.84667 0.468959 2.10875 0.281459C2.37083 0.0938196 2.66417 0 2.98875 0H11.1779C11.5025 0 11.7958 0.0938196 12.0579 0.281459C12.32 0.468959 12.501 0.712778 12.6008 1.01292L14.0931 5.23208C14.1197 5.31139 14.1385 5.39431 14.1498 5.48083C14.161 5.56736 14.1667 5.65389 14.1667 5.74042V11.6185C14.1667 11.8634 14.0809 12.0715 13.9094 12.2429C13.7377 12.4143 13.5294 12.5 13.2844 12.5C13.0392 12.5 12.8312 12.4143 12.6602 12.2429C12.4894 12.0715 12.404 11.8634 12.404 11.6185V10.8333H1.76271ZM1.75646 4.23083H12.4102L11.4231 1.41833C11.4017 1.36486 11.3697 1.32347 11.3269 1.29417C11.2841 1.26472 11.2333 1.25 11.1746 1.25H2.99208C2.93333 1.25 2.88257 1.26472 2.83979 1.29417C2.79701 1.32347 2.76493 1.36486 2.74354 1.41833L1.75646 4.23083ZM3.30312 8.62187C3.60632 8.62187 3.86347 8.51569 4.07458 8.30333C4.28556 8.09111 4.39104 7.8334 4.39104 7.53021C4.39104 7.22701 4.28493 6.96986 4.07271 6.75875C3.86035 6.54778 3.60257 6.44229 3.29938 6.44229C2.99618 6.44229 2.7391 6.5484 2.52813 6.76062C2.31701 6.97299 2.21146 7.23076 2.21146 7.53396C2.21146 7.83715 2.31764 8.09424 2.53 8.30521C2.74222 8.51632 2.99993 8.62187 3.30312 8.62187ZM10.8673 8.62187C11.1705 8.62187 11.4276 8.51569 11.6385 8.30333C11.8497 8.09111 11.9552 7.8334 11.9552 7.53021C11.9552 7.22701 11.849 6.96986 11.6367 6.75875C11.4244 6.54778 11.1667 6.44229 10.8635 6.44229C10.5603 6.44229 10.3032 6.5484 10.0921 6.76062C9.88111 6.97299 9.77563 7.23076 9.77563 7.53396C9.77563 7.83715 9.88174 8.09424 10.094 8.30521C10.3063 8.51632 10.5641 8.62187 10.8673 8.62187ZM1.25 9.58333H12.9167V5.48083H1.25V9.58333Z"
        fill="currentColor"
      />
    </svg>
  );
}

type DetailKind = "hotel" | "flight" | "car";

function resolveAmenityKind(label: string): DetailKind {
  const value = label.trim().toLowerCase();
  if (["vuelo", "vuelos", "flight", "flights"].includes(value)) {
    return "flight";
  }
  if (["auto", "autos", "car", "cars", "traslado", "transfer", "transfers"].includes(value)) {
    return "car";
  }
  return "hotel";
}

function DetailIcon({ kind }: { kind: DetailKind }) {
  if (kind === "flight") {
    return <FlightIcon />;
  }
  if (kind === "car") {
    return <CarIcon />;
  }
  return <HotelIcon />;
}

function PromoIcon() {
  return (
    <svg
      className={PACKAGE_CARD_STYLES.promoIcon}
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M4.56661 4.85465C4.47587 5.06583 4.57373 5.31079 4.78532 5.40153L6.2819 6.04328L4.77698 7.54833H3.77091C3.54081 7.54833 3.35425 7.7347 3.35425 7.965C3.35425 8.1953 3.54081 8.38167 3.77091 8.38167H4.53284V9.14379C4.53284 9.3741 4.7194 9.56046 4.9495 9.56046C5.17961 9.56046 5.36617 9.3741 5.36617 9.14379V8.13753L6.87119 6.6324L7.51277 8.12898C7.60181 8.33667 7.85209 8.43795 8.05985 8.3479C8.27124 8.25716 8.3693 8.0122 8.27856 7.80102L7.50575 5.99779L8.19026 5.31323C8.35302 5.15047 8.35302 4.8868 8.19026 4.72404C8.0275 4.56128 7.76383 4.56128 7.60107 4.72404L6.91651 5.40865L5.11369 4.63574C4.90291 4.54419 4.65735 4.64306 4.56661 4.85465Z"
        fill="white"
      />
      <path
        d="M9.58329 9.58333C9.8134 9.58333 9.99996 9.39697 9.99996 9.16667V7.91667C9.99996 7.68636 9.8134 7.5 9.58329 7.5C9.35319 7.5 9.16663 7.68636 9.16663 7.91667V9.16667C9.16663 9.39697 9.35319 9.58333 9.58329 9.58333Z"
        fill="white"
      />
      <path
        d="M9.58329 6.66927C9.8134 6.66927 9.99996 6.48291 9.99996 6.2526V5.0026C9.99996 4.7723 9.8134 4.58594 9.58329 4.58594C9.35319 4.58594 9.16663 4.7723 9.16663 5.0026V6.2526C9.16663 6.48291 9.35319 6.66927 9.58329 6.66927Z"
        fill="white"
      />
      <path
        d="M14.5833 0H2.91667C2.22738 0 1.66667 0.560708 1.66667 1.25V1.66667H1.25C0.560708 1.66667 0 2.22738 0 2.91667V5.41667C0 5.64697 0.186562 5.83333 0.416667 5.83333C1.10596 5.83333 1.66667 6.39404 1.66667 7.08333C1.66667 7.77262 1.10596 8.33333 0.416667 8.33333C0.186562 8.33333 0 8.5197 0 8.75V11.25C0 11.9393 0.560708 12.5 1.25 12.5H12.9167C13.606 12.5 14.1667 11.9393 14.1667 11.25V10.8333H14.5833C15.2726 10.8333 15.8333 10.2726 15.8333 9.58333V1.25C15.8333 0.560708 15.2726 0 14.5833 0ZM15 9.58333C15 9.81323 14.813 10 14.5833 10H14.1667V8.75C14.1667 8.5197 13.9801 8.33333 13.75 8.33333C13.0607 8.33333 12.5 7.77262 12.5 7.08333C12.5 6.39404 13.0607 5.83333 13.75 5.83333C13.9801 5.83333 14.1667 5.64697 14.1667 5.41667V2.91667C14.1667 2.22738 13.606 1.66667 12.9167 1.66667H6.25C6.0199 1.66667 5.83333 1.85303 5.83333 2.08333C5.83333 2.31364 6.0199 2.5 6.25 2.5H9.16667V3.33333C9.16667 3.56364 9.35323 3.75 9.58333 3.75C9.81344 3.75 10 3.56364 10 3.33333V2.5H12.9167C13.1464 2.5 13.3333 2.68677 13.3333 2.91667V5.04191C12.3836 5.2356 11.6667 6.07707 11.6667 7.08333C11.6667 8.0896 12.3836 8.93107 13.3333 9.12475V11.25C13.3333 11.4799 13.1464 11.6667 12.9167 11.6667H10V10.8333C10 10.603 9.81344 10.4167 9.58333 10.4167C9.35323 10.4167 9.16667 10.603 9.16667 10.8333V11.6667H1.25C1.0203 11.6667 0.833333 11.4799 0.833333 11.25V9.12475C1.78304 8.93107 2.5 8.0896 2.5 7.08333C2.5 6.07707 1.78304 5.2356 0.833333 5.04191V2.91667C0.833333 2.68677 1.0203 2.5 1.25 2.5H4.58333C4.81344 2.5 5 2.31364 5 2.08333C5 1.85303 4.81344 1.66667 4.58333 1.66667H2.5V1.25C2.5 1.0201 2.68697 0.833333 2.91667 0.833333H14.5833C14.813 0.833333 15 1.0201 15 1.25V9.58333Z"
        fill="white"
      />
    </svg>
  );
}

function InfoIcon() {
  return (
    <svg
      className={PACKAGE_CARD_STYLES.priceInfoIcon}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M7.75708 11.6225C7.91736 11.6225 8.05451 11.5654 8.16854 11.4513C8.28257 11.3371 8.33958 11.1992 8.33958 11.0375V7.51271C8.33958 7.35424 8.28236 7.21778 8.16792 7.10333C8.05361 6.98903 7.91715 6.93187 7.75854 6.93187C7.59687 6.93187 7.45903 6.98903 7.345 7.10333C7.23083 7.21778 7.17375 7.35424 7.17375 7.51271V11.0375C7.17375 11.1992 7.2309 11.3371 7.34521 11.4513C7.45938 11.5654 7.59667 11.6225 7.75708 11.6225ZM7.74604 5.55604C7.92979 5.55604 8.08264 5.49576 8.20458 5.37521C8.32667 5.25451 8.38771 5.10236 8.38771 4.91875C8.38771 4.73514 8.32743 4.58229 8.20687 4.46021C8.08632 4.33826 7.93424 4.27729 7.75062 4.27729C7.56687 4.27729 7.41403 4.33757 7.29208 4.45813C7.17 4.57868 7.10896 4.73076 7.10896 4.91437C7.10896 5.09799 7.16924 5.25083 7.28979 5.37292C7.41035 5.495 7.56243 5.55604 7.74604 5.55604ZM7.75021 15.4967C6.67868 15.4967 5.67132 15.2931 4.72813 14.8858C3.78479 14.4785 2.96424 13.9257 2.26646 13.2275C1.56882 12.5293 1.01667 11.7095 0.61 10.7681C0.203333 9.8266 0 8.82063 0 7.75021C0 6.67868 0.203611 5.67132 0.610833 4.72813C1.01819 3.78479 1.57097 2.96424 2.26917 2.26646C2.96736 1.56882 3.78715 1.01667 4.72854 0.609999C5.67007 0.203333 6.67604 0 7.74646 0C8.81799 0 9.82535 0.203611 10.7685 0.610834C11.7119 1.01819 12.5324 1.57097 13.2302 2.26917C13.9278 2.96736 14.48 3.78715 14.8867 4.72854C15.2933 5.67007 15.4967 6.67604 15.4967 7.74646C15.4967 8.81799 15.2931 9.82535 14.8858 10.7685C14.4785 11.7119 13.9257 12.5324 13.2275 13.2302C12.5293 13.9278 11.7095 14.48 10.7681 14.8867C9.8266 15.2933 8.82063 15.4967 7.75021 15.4967ZM7.74812 14.3308C9.57993 14.3308 11.135 13.6918 12.4133 12.4137C13.6917 11.1356 14.3308 9.58049 14.3308 7.74854C14.3308 5.91674 13.6918 4.36167 12.4137 3.08333C11.1356 1.805 9.58049 1.16583 7.74854 1.16583C5.91674 1.16583 4.36167 1.80486 3.08333 3.08292C1.805 4.36111 1.16583 5.91618 1.16583 7.74812C1.16583 9.57993 1.80486 11.135 3.08292 12.4133C4.36111 13.6917 5.91618 14.3308 7.74812 14.3308Z"
        fill="currentColor"
      />
    </svg>
  );
}

export const PackageCard = React.forwardRef<HTMLAnchorElement, PackageCardProps>(
  (
    {
      className,
      imageUrl,
      name,
      location,
      amenities = [],
      hotelInfo,
      routeInfo,
      price,
      originalPrice,
      currency,
      locale = "es-MX",
      fromLabel = "Desde",
      pricePerLabel,
      datesLabel,
      promoLabel,
      foundAgoLabel,
      detailsHref,
      onClick,
      ...props
    },
    ref
  ) => {
    const detailRows =
      hotelInfo || routeInfo
        ? [
            ...(hotelInfo ? [{ kind: "hotel" as const, label: hotelInfo }] : []),
            ...(routeInfo ? [{ kind: "flight" as const, label: routeInfo }] : []),
          ]
        : amenities.map((label) => ({
            kind: resolveAmenityKind(label),
            label,
          }));

    return (
      <div className={cn(PACKAGE_CARD_STYLES.shell, className)}>
        <a
          ref={ref}
          href={detailsHref}
          className={PACKAGE_CARD_STYLES.root}
          onClick={(event) => {
            onClick?.(event);
          }}
          {...props}
        >
          <div className={PACKAGE_CARD_STYLES.imageWrapper}>
            <img
              src={imageUrl}
              alt={name}
              className={PACKAGE_CARD_STYLES.image}
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className={PACKAGE_CARD_STYLES.body}>
            <h3 className={PACKAGE_CARD_STYLES.name}>{name}</h3>
            <p className={PACKAGE_CARD_STYLES.location}>{location}</p>

            <div className={PACKAGE_CARD_STYLES.detailsBlock}>
              {detailRows.map((row) => (
                <p key={`${row.kind}-${row.label}`} className={PACKAGE_CARD_STYLES.detailRow}>
                  <DetailIcon kind={row.kind} />
                  <span>{row.label}</span>
                </p>
              ))}
            </div>

            {promoLabel && (
              <span className={PACKAGE_CARD_STYLES.promoChip}>
                <PromoIcon />
                {promoLabel}
              </span>
            )}

            <div className={PACKAGE_CARD_STYLES.priceBlock}>
              <p className={PACKAGE_CARD_STYLES.price}>
                <span className={PACKAGE_CARD_STYLES.fromLabel}>{fromLabel}</span>
                {formatCurrency(price, currency, locale)}
                {originalPrice && originalPrice > price && <InfoIcon />}
                {originalPrice && originalPrice > price && (
                  <span className={PACKAGE_CARD_STYLES.originalPrice}>
                    {formatCurrency(originalPrice, currency, locale)}
                  </span>
                )}
              </p>
              <p className={PACKAGE_CARD_STYLES.pricePerLabel}>{pricePerLabel}</p>
              <p className={PACKAGE_CARD_STYLES.datesLabel}>{datesLabel}</p>
              <p className={PACKAGE_CARD_STYLES.foundAgoLabel}>
                {foundAgoLabel}
              </p>
            </div>
          </div>
        </a>
      </div>
    );
  }
);

PackageCard.displayName = "PackageCard";
